import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from 'react';
// import { useGlobalContext } from "../../context/context";
import { FaChevronDown } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import { MdOutlineDone } from 'react-icons/md';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Law from './Law';
import { DataContext } from '../context/DataProvider';

const SearchLawDropDown = ({search,fetchlist}) => {
  const [pageNumber, setPageNumebr] = useState(1);
  const [openMenu, setOpenMenu] = useState(false);
  const observe = useRef();
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [searchText, setSearchText] = useState('');
  const [lawTitle, setLawTitle] = useState('');
  const { OptionSearch, setOption, ValueForSearch,setValueForSearch }: any = useContext(DataContext);
  const { loading, error, hasMore, ReLawArray } = Law(searchText, pageNumber);
  // console.log(ReLawArray) 
  const handelChange = (e) => {
    if (lawTitle !== '') {
      setLawTitle('');
    }
    setSearchText(e.target.value);
    setPageNumebr(1);
    setLawTitle(e.target.value);
    // setsearchtitleid(e.target.value);
  };
  const handleonClick = () => {
    setOpenMenu(!openMenu);
  };
  // console.log()
  const lastorgElement = useCallback(
    (node) => {
      if (loading) return;
      if (observe.current) observe.current.disconnect();
      observe.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumebr((prevPageNumber) => prevPageNumber + 1);
          // console.log("visiable");
        }
      });
      //   if (node) observer.current
      //   console.log(node);
      if (node) observe.current.observe(node);
    },
    [loading, hasMore],
  );
  const handleClick = (item: any) => {
    setOption({
      value: item.value,
      label: item.label,
    });
    search();
   setValueForSearch(item)
    setOpenMenu(false);
    setLawTitle(item.label);
    
  };
  const emptyInput = (e: any) => {
    e.preventDefault();
    setLawTitle('');
    setOption({
      value: 0,
      label: '',
    });
    setSearchText('');
    setValueForSearch({})
  setLawTitle('')
    setOpenMenu(false);
    fetchlist({})
  };
  return (
    <>
      <div className="w-full rtl  flex flex-col font-IranSans">
        <div className=" rtl   py-1 flex items-center  font-IranSans">
          <div className="flex w-[80%]">
            <span className="inline-flex items-center px-3
             text-sm text-gray-900 bg-gray-200 border rounded-e-0 
             border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600
              dark:text-gray-400 dark:border-gray-600">
              {openMenu ? (
                <>
                  {/* <div className="text-gray-400">|</div> */}
                  <button className=" ltr   text-center">
                    <FaChevronDown className="text-[15px] text-gray-400" />
                  </button>
                </>
              ) : (
                <>
                  <button className="" onClick={emptyInput}>
                    <IoIosClose className="text-[20px] text-gray-400" />
                  </button>
                </>
              )}
            </span>
            <input
              placeholder="جستجوی قانون "
              onChange={handelChange}
              onClick={handleonClick}
              value={lawTitle}
              type="text"
              id="website-admin"
              className="rounded-none focus:outline-none w-full rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 
              min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
              dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            
            />
          </div>
          {/* <input
              className="border-2 relative  border-gray-200 text-[14px] p-2  rounded-md w-[80%] text-right focus:outline-none"
             
              placeholder="جستجوی قانون "
              onChange={handelChange}
              onClick={handleonClick}
              value={lawTitle}
            />
            <div className=" absolute rtl bg-[#475569] left-[100rem] flex items-center justify-center rounded-md px-2">
              {openMenu ? (
                <>
                  <div className="text-gray-400">|</div>
                  <button className=" ltr   text-center">
                    <FaChevronDown className="text-[20px] text-gray-400" />
                  </button>
                </>
              ) : (
                <>
                  <button className="" onClick={emptyInput}>
                    <IoIosClose className="text-[20px] text-gray-400" />
                  </button>
                </>
              )}
            </div> */}
          {/* <div className=""><FaChevronDown /></div> */}
        </div>
        {openMenu && (
          <div className="w-[35%] bg-white md:ml-[4.5rem] absolute rtl z-10 h-52 border rounded-md mt-12  overflow-y-auto">
            {Array.from(ReLawArray).map((i, index) => {
              if (Array.from(ReLawArray).length === index + 1) {
                return (
                  <>
                    <div
                      onClick={() => handleClick(i)}
                      ref={lastorgElement}
                      key={i.index}
                      className="cursor-pointer text-justify hover:bg-blue-100 py-2 px-1"
                    >
                      <p className="pr-2 text-justify flex item-center ">
                        {/* <MdOutlineDone className="pl-2 text-[2rem]" /> */}
                        {i.label}
                      </p>
                      <p className="text-[15px] text-gray-400 p-2"> {i.ApproveDate}</p>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div
                      onClick={() => handleClick(i)}
                      className="cursor-pointer text-justify hover:bg-blue-100 py-2 px-1"
                      key={i.index}
                    >
                      <p className="pr-2 text-justify flex item-center ">
                        {/* <MdOutlineDone className="pl-2 text-[2rem]" /> */}
                        {i.label}
                      </p>

                      <p className="text-[15px] text-gray-400 p-2"> {i.ApproveDate}</p>
                    </div>
                    <hr />
                  </>
                );
              }
            })}

            <div>{loading && 'loading...'}</div>
            {/* {error && <div>error...</div>} */}
          </div>
        )}
      </div>
    </>
  );
};

export default SearchLawDropDown;
